module.exports = __webpack_public_path__ + "static/media/companies-icon-4.abcf7196.svg";